module.exports = ".profile-circle-img {\n  background: no-repeat 50%;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n  width: 80px;\n  height: 80px;\n  background-size: 80px 80px;\n  -webkit-box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.16);\n          box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.16); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/inline-profile/inline-profile.component.scss
// module id = ./src/app/home/inline-profile/inline-profile.component.scss
// module chunks = main